export default __webpack_public_path__ + "static/media/wifi.4e3160c5.svg";